import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Passeios from "./pages/Passeios";
import PasseioDetalhe from "./pages/PasseioDetalhe";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-sand text-ink font-sans pb-[52px] md:pb-0">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/passeios" element={<Passeios />} />
          <Route path="/passeios/:slug" element={<PasseioDetalhe />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
